/** Reserved member ID for "All Members" - a special assignment that applies to everyone. */
export const ALL_MEMBERS_ID = "00000000-0000-0000-0000-000000000001";
